// extracted by mini-css-extract-plugin
export var container = "_7k-0";
export var fallback = "_7k-5";
export var fallbackIcon = "_7k-6";
export var hidden = "_7k-2";
export var image = "_7k-3";
export var loaded = "_7k-4";
export var placeholder = "_7k-1";